import BaseComponent from '@/components/base';
import Style from '@/components/accordion-advanced/accordion-header/style';

export default class AccordionHeader extends BaseComponent {
  arrowRightIcon = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Chevron right">
      <path id="Icon" d="M6 12L10 8L6 4" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>`;

  arrowDownIcon = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Chevron right">
      <path id="Icon" d="M4 6L8 10L12 6" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>`;

  render() {
    return `
      ${Style}
      <section class="accordion-advanced-header">
        <span class="icon accordion-arrow-icon accordion-arrow-right">${this.arrowRightIcon}</span>
        <span class="icon accordion-arrow-down">${this.arrowDownIcon}</span>
        <slot></slot>
      </section>
    `;
  }
}
